// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scenario-chip i {\n  margin-right: -0.2em !important;\n}", ""]);
// Exports
module.exports = exports;
